import React from 'react';
import './MainTitle.css';
class MainTitle extends React.Component {
    render() {
        return (
            <h1 className="heading">Xmeme</h1>
        )
    }
}

export default MainTitle;